import React from 'react';

export interface FiltrosIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const FiltrosIcon: React.FC<FiltrosIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <g filter="url(#a)"><path stroke="currentColor" stroke-linecap="round" stroke-width="1.5" d="M12.786 7.313H4.75m13.393 0h8.036m-5.358 8.151H4.75m5.357 8.151H26.18m-16.286.009a2.571 2.571 0 1 0-5.143 0 2.571 2.571 0 0 0 5.143 0Zm16.071-8.151a2.571 2.571 0 1 0-5.142 0 2.571 2.571 0 0 0 5.142 0ZM17.93 7.32a2.571 2.571 0 1 0-5.143 0 2.571 2.571 0 0 0 5.143 0Z"/></g><defs><filter id="a" width="32" height="32" x="-.126" y="-.372" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"/><feBlend in2="BackgroundImageFix" mode="overlay" result="effect1_dropShadow_23_63364"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend in2="effect1_dropShadow_23_63364" mode="multiply" result="effect2_dropShadow_23_63364"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_23_63364" result="shape"/></filter></defs>
    </svg>
  );
};

export default FiltrosIcon;
